import { useNavigate, useParams, useSearch } from '@tanstack/react-router';
import { MarketplacePostForm } from '@anytag/shared-organisms';
import { useMarketplaceDetailsContext } from '../marketplace-details-context';
import { MarketplaceEditPostSearchSchemaType } from './schema-types';

export const MarketplaceEditPost = () => {
  const navigate = useNavigate({ from: '/marketplace/$id/posts' });
  const { marketplaceId, isAffiliateCampaign } = useMarketplaceDetailsContext();
  const params = useParams({ from: '/_private-routes/marketplace/$id/posts/$postId' });
  const search = useSearch({
    from: '/_private-routes/marketplace/$id/posts/$postId'
  }) as MarketplaceEditPostSearchSchemaType;

  const postId = Number(params.postId ?? '');

  const goToPostsList = () => {
    navigate({
      to: '/marketplace/$id/posts',
      search,
      replace: true
    });
  };

  if (!postId) {
    goToPostsList();

    return null;
  }

  return (
    <MarketplacePostForm
      postId={postId}
      onClose={goToPostsList}
      marketplaceId={marketplaceId}
      isAffiliateCampaign={isAffiliateCampaign}
      isDraftPost={search.filter.draftPost === Boolean(true).toString()}
    />
  );
};
